var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(7 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.472 10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.184,7.352,13.957,8.579l1.375,1.384H8.222V11.7h7.11l-1.375,1.375,1.227,1.236,3.481-3.481ZM4.741,4.741h6.092V3H4.741A1.746,1.746,0,0,0,3,4.741V16.925a1.746,1.746,0,0,0,1.741,1.741h6.092V16.925H4.741Z",
    transform: "translate(-4.471 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.0fb2e6266363726b785180901c2c25bb.svg";
export { ForwardRef as ReactComponent };